import React, { useMemo } from 'react'
import styled from 'styled-components'
import Files from './files'
import Upload from './upload'
import PrepareEsign from './prepare-esign'
import Options from './options'
import Status from './status'
import Title from './title'
import Divider from './divider'
import SignatureRequests from './signature-requests'
import {
  combineFiles,
  sortFiles,
  shouldPreventManualFileCreation,
} from './utils'
import { getShallowStatus } from './status/utils'
import {
  EsignVendors,
  DocumentEsignStatuses,
  DocumentStatusOption,
} from './constants'

const ContainerElement = styled.div``

const HeaderElement = styled.header`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  gap: 0.5rem;
`

const OwnerAndOptionsWrapperElement = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`

const OwnerElement = styled.p`
  font-size: 0.8rem;
  font-style: italic;
  color: #9a9a9c;
  text-align: center;
  margin: 0;
`

const FooterElement = styled.footer`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  gap: 0.5rem;
`

function Document({
  loanId,
  document,
  guarantors,
  entity,
  resourceType,
  isArchived,
}) {
  const {
    title,
    status,
    adminOnly,
    esignable,
    rid: documentId,
    esignVendor,
    documentKey,
    esignStatus,
  } = document

  const files = useMemo(() => sortFiles(combineFiles(document)), [document])
  const showBlueBar = useMemo(
    () =>
      esignVendor === EsignVendors.DocuSign
        ? documentKey &&
          esignStatus !== DocumentEsignStatuses.voided &&
          esignStatus !== DocumentEsignStatuses.completed
        : status === DocumentStatusOption.esign_requested,
    [esignVendor, documentKey, esignStatus, status],
  )

  return (
    <ContainerElement>
      <HeaderElement>
        <Title title={title} status={getShallowStatus(document)} />
        <Status document={document} resourceType={resourceType} />
        <OwnerAndOptionsWrapperElement>
          <OwnerElement>
            {adminOnly ? 'Admin' : 'Applicant'} document
          </OwnerElement>
          <Options
            loanId={loanId}
            document={document}
            entity={entity}
            isArchived={isArchived}
          />
        </OwnerAndOptionsWrapperElement>
      </HeaderElement>
      <Divider />
      <Files documentId={documentId} files={files} />
      {esignable && showBlueBar && (
        <SignatureRequests
          documentId={documentId}
          esignVendor={esignVendor}
          documentKey={documentKey}
          esignStatus={esignStatus}
        />
      )}
      <Divider />
      <FooterElement>
        <Upload
          documentId={documentId}
          preventUpload={shouldPreventManualFileCreation(document)}
        />
        <div />
        {esignable && (
          <PrepareEsign
            loanId={loanId}
            document={document}
            guarantors={guarantors}
            files={files}
            // Sending flag as prop to prevent modal from closing when unmounted
            showBlueBar={showBlueBar}
          />
        )}
      </FooterElement>
    </ContainerElement>
  )
}

export default Document
